import React from 'react'
import Collapsible from '../Collapsible/Collapsible'
import { useCollapsible } from 'client/fragments/listerFragment/components/Filters/Collapsible/useCollapsible'
import { AnimatePresence } from 'framer-motion'
import { ListFilterItems } from './ListFilterItems'

export const ListFilter = ({ filter, preventClick, onChange, buttonActiveText, buttonInactiveText }) => {
  const { isCollapsed, setIsCollapsed } = useCollapsible()

  return (
    <Collapsible isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} dataTestId='list' dataValue={filter.name}>
      <Collapsible.Header>{filter.title}</Collapsible.Header>
      <AnimatePresence initial={false}>
        {!isCollapsed && (
          <Collapsible.Body>
            <ListFilterItems
              filter={filter}
              preventClick={preventClick}
              onChange={onChange}
              buttonActiveText={buttonActiveText}
              buttonInactiveText={buttonInactiveText}
              className='mxd-mcollapse-body mxd-mcollapse-list'
              filterPosition='side'
            />
          </Collapsible.Body>
        )}
      </AnimatePresence>
    </Collapsible>
  )
}
